/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_TagsInputs */

const cs_clients_filter_tags = /** @type {(inputs: Clients_Filter_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat podle štítků`)
};

const en_clients_filter_tags = /** @type {(inputs: Clients_Filter_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by tags`)
};

/**
* | output |
* | --- |
* | "Filter by tags" |
*
* @param {Clients_Filter_TagsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_tags = /** @type {((inputs?: Clients_Filter_TagsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_TagsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_tags(inputs)
	return cs_clients_filter_tags(inputs)
});